<template>
    <div id="mytask-layout" class="theme-indigo">
      <!--Menu Sidebar-->
      <div id="main-menu">
        <div class="sidebar me-0">
          <div class="d-flex flex-column h-100">
            <RouterLink to="/dashboard-institute">
              <a href="#" class="brand-icon dashboard-link justify-content-center">
                <span class="logo-icon">
                  <img src="../assets/images/logo_small.png" class="logo-img" style="width:8em" alt="Citrine Logo" >
                </span>
              </a>
            </RouterLink>
          
            <!-- Menu: main ul -->
            <ul class="menu-list flex-grow-1 mt-5">
    <li v-if="userInfo" class="menu-link" :class="{ active: isActive('/dashboard-institute') }">
      <RouterLink to="/dashboard-institute" class="d-flex align-items-center justify-content-start">
        <img src="../assets/images/home16.png" alt="Citrine Logo" class="menu-img" style="width:1.3em; margin-right:5px">
        <span style="font-size:small">Αρχική</span>
      </RouterLink>
    </li>
  
    <li v-if="userInfo" class="menu-link" :class="{ active: isActive('/import-implant-statement') }">
      <RouterLink to="/import-implant-statement" class="d-flex align-items-center justify-content-start">
        <img src="../assets/images/plus16.png" alt="Citrine Logo" class="menu-img" style="width:1.3em; margin-right:5px">
        <span style="font-size:small">Δήλωση εισαγωγής μοσχεύματος</span>
      </RouterLink>
    </li>
  
    <li v-if="userInfo" class="menu-link" :class="{ active: isActive('/stated-implants') }">
      <RouterLink to="/stated-implants" class="d-flex align-items-center justify-content-start">
        <img src="../assets/images/total16.png" alt="Citrine Logo" class="menu-img" style="width:1.3em; margin-right:5px">
        <span style="font-size:small">Δηλωθέντα Μοσχεύματα</span>
      </RouterLink>
    </li>
  
    <li v-if="userInfo" class="menu-link" :class="{ active: isActive('/apply-implant-statement') }">
      <RouterLink to="/apply-implant-statement" class="d-flex align-items-center justify-content-start">
        <img src="../assets/images/plus16.png" alt="Citrine Logo" class="menu-img" style="width:1.3em; margin-right:5px">
        <span style="font-size:small">Δήλωση Διανομής Μοσχεύματος</span>
      </RouterLink>
    </li>
  
    <li v-if="userInfo" class="menu-link" :class="{ active: isActive('/implants-to-apply') }">
      <RouterLink to="/implants-to-apply" class="d-flex align-items-center justify-content-start">
        <img src="../assets/images/implant16.png" alt="Citrine Logo" class="menu-img" style="width:1.3em; margin-right:5px">
        <span style="font-size:small">Μοσχεύματα προς εφαρμογή</span>
      </RouterLink>
    </li>
  
    <li v-if="userInfo" class="menu-link" :class="{ active: isActive('/applied-implants') }">
      <RouterLink to="/applied-implants" class="d-flex align-items-center justify-content-start">
        <img src="../assets/images/medical16.png" alt="Citrine Logo" class="menu-img" style="width:1.3em; margin-right:5px">
        <span style="font-size:small">Διανεμηθέντα Μοσχεύματα</span>
      </RouterLink>
    </li>

    <li v-if="userInfo" class="menu-link" :class="{ active: isActive('/expired-implants') }">
      <RouterLink to="/expired-implants" class="d-flex align-items-center justify-content-start">
        <img src="../assets/images/warning16.png" alt="Citrine Logo" class="menu-img" style="width:1.3em; margin-right:5px">
        <span style="font-size:small">Ληγμένα Μοσχεύματα</span>
      </RouterLink>
    </li>

  <li v-if="userInfo" class="menu-link">
  <div @click="showTempSubmenu = !showTempSubmenu" class="d-flex align-items-center justify-content-start" style="cursor: pointer;">
    <img src="../assets/images/temp16.png" alt="Citrine Logo" class="menu-img" style="width:1.3em; margin-right:5px">
    <span style="font-size:small">Προσωρινά Αποθηκευμένα</span>
    <span class="ms-auto">
      <i :class="showTempSubmenu ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
    </span>
  </div>

  <!-- Submenu -->
  <ul v-if="showTempSubmenu" class="submenu ps-4">
    <li :class="{ active: isActive('/temp-saved-applies') }">
      <RouterLink to="/temp-saved-applies" class="d-flex align-items-center justify-content-start">
        <span style="font-size:small">Προς Δήλωση</span>
      </RouterLink>
    </li>
    <li :class="{ active: isActive('/temp-saved-implants') }">
      <RouterLink to="/temp-saved-implants" class="d-flex align-items-center justify-content-start">
        <span style="font-size:small">Προς Διανομή</span>
      </RouterLink>
    </li>
  </ul>
</li>

 <li v-if="userInfo" class="menu-link" :class="{ active: isActive('/institutions-manual') }">
  <RouterLink to="/institutions-manual" class="d-flex align-items-center justify-content-start">
    <img src="../assets/images/pdf.svg" alt="Manual" class="menu-img" style="width:1.3em; margin-right:5px">
    <span style="font-size:small">Εγχειρίδιο Χρήσης</span>
  </RouterLink>
</li> 

  </ul>
  
  
  
            <!-- Menu: menu collapse btn -->
            <button type="button" class="btn btn-link sidebar-mini-btn text-light" style="" @click="toggleSidebarMini">
            <span class="ms-2"><i class="icofont-bubble-right"></i></span>
          </button>
          </div>
        </div>
      </div>
      <!-- End of Menu Sidebar -->
  
      <!-- main body area -->
      <div class="main px-lg-4 px-md-4">
        <!--Navigation bar-->
        <div id="main-header">
          <nav class="navbar mt-3">
            <div class="container-xxl mb-0" >
              <!-- header rightbar icon -->
              <div class="h-right d-flex align-items-center mr-5 mr-lg-0 order-1">
                <div class="d-flex"></div>
                <div class="x-panel-body-default user-menu mb-4"  @click.prevent="toggleMenu()">
                  <img src="../assets/images/user16.png" alt="Citrine Logo" class="menu-img" style="width:1.3em; margin-right:5px; margin-bottom:2px">
                  <span v-if="userInfo?.institution?.title">{{ userInfo.institution.title }}</span>

                  <i class="icofont-arrow-down ms-1"></i>
                </div>
              
                <div class="dropdown user-profile  d-flex align-items-center zindex-popover">
                 
                  
                  <div
                    :class="{ 'dropdown-menu user-menu rounded-lg shadow border-0 dropdown-animation dropdown-menu-end p-0 m-0': !isMenuOpen, 'dropdown-menu user-menu rounded-lg shadow border-0 dropdown-animation dropdown-menu-end p-0 m-0 show': isMenuOpen }"
                    :style="menuStyle">
                    <div class="card border-0 w150">
                      
                      <div class="list-group m-2">
                        
                        
                        <a @click.prevent="info" href="#" style="font-size:small"
                          class="list-group-item list-group-item-action border-0 btn-logout">
                          <img src="../assets/images/info16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em">
                          Πληροφορίες</a>

                          <a @click.prevent="logout" href="#" style="font-size:small"
                          class="list-group-item list-group-item-action border-0 btn-logout">
                          <img src="../assets/images/logout16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em">
                          Αποσύνδεση</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <!-- menu toggler -->
            <!--   <button class="navbar-toggler p-0 border-0 menu-toggle order-3" type="button" @click="toggleSidebar">
                <span class="fa fa-bars"></span>
              </button> -->
  
  
              <!-- main menu Search-->
               <div class="mx-auto text-center">
          <h4 class="mb-0 text-uppercase font-weight-bold" style="font-size: 20px;
      color: #2279B3;">
            ΠΑΡΑΚΟΛΟΥΘΗΣΗ ΚΑΙ ΕΛΕΓΧΟΣ ΔΙΑΚΙΝΗΣΗΣ
          </h4>
          <h4 class="mb-0 text-uppercase font-weight-bold" style="font-size: 20px;
      color: #2279B3;">          ΙΣΤΙΚΩΝ ΜΟΣΧΕΥΜΑΤΩΝ        </h4>
        </div>
            </div>
          </nav>
        </div>
        <!--end of Navigation bar-->
  
        <div id="main-container">
          <LoadingSpinner :isLoading="isLoading" />
          <slot></slot>
        </div>
      </div>

       <!-- Modal for Info -->
       <div class="modal fade" id="modal-info" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Πληροφορίες Χρήστη</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <!-- Form for Adding/Editing Institute -->
                        <form>
                            
                          <div class="implant-details-container">
            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Όνομα</strong>
                <div class="value-text"  v-if="userInfo?.institution?.title">{{ userInfo.institution.title }}</div>
            </div>
            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Διεύθυνση</strong>
                <div class="value-text"  v-if="userInfo?.institution?.title">{{ userInfo.institution.address }}</div>
            </div>
            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Τηλέφωνο</strong>
                <div class="value-text"  v-if="userInfo?.institution?.title">{{ userInfo.institution.phone }}</div>
            </div>
            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Email</strong>
                <div class="value-text"  v-if="userInfo?.institution?.title">{{ userInfo.institution.email }}</div>
            </div>
            <div class="implant-detail shadow mb-2">
                <strong class="label-text">Yπεύθυνος Επικοινωνίας</strong>
                <div class="value-text"  v-if="userInfo?.institution?.title">{{ userInfo.institution.responsible }}</div>
            </div>
           
</div>
<div class="modal-footer">
                                <button type="button" class="btn2" data-bs-dismiss="modal"><img src="../assets/images/close16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Κλείσιμο</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template>
  
  <script>
  import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  import { fetchUserInfo, fetchUsers, changeUser, getAllUnreadNotifications, logoutUser } from '../services/user'; // Adjust this import as needed
  import { useToast } from 'vue-toastification';
  import 'vue-toastification/dist/index.css';
  import LoadingSpinner from '../components/LoadingSpinner.vue';
  import { mapActions } from 'vuex';
  import { mapGetters } from 'vuex';
  
  
  
  // Define a reactive variable to track whether the current mode is light or dark
  const isLightMode = ref(false);
  
  export default {
    name: 'MainLayout',
    components: {
      LoadingSpinner
    },
    data() {
    return {
      userInfo: null,
          showTempSubmenu: false
    };
  },
    mounted() {
      this.fetchUserData();
    },
    methods: {
      ...mapActions(['fetchUserData']),
    },
    computed: {
      ...mapGetters({
        getUserPermission: 'getUserPermission',
        getSuperUserPermission: 'getSuperUserPermission'
  
      }),
      userPermissionsProjects() {
        return this.getUserPermission('Projects');
      },
      canViewProjects() {
        return this.userPermissionsProjects?.view === 1;
      },
      userPermissionsUsers() {
        return this.getUserPermission('Users');
      },
      canViewUsers() {
        return this.userPermissionsUsers?.view === 1;
      },
      userPermissionsServices() {
        return this.getUserPermission('Services');
      },
      canViewServices() {
        return this.userPermissionsServices?.view === 1;
      },
      userPermissionsSuppliers() {
        return this.getUserPermission('Suppliers');
      },
      canViewSuppliers() {
        return this.userPermissionsSuppliers?.view === 1;
      },
      userPermissionsClients() {
        return this.getUserPermission('Clients');
      },
      canViewClients() {
        return this.userPermissionsClients?.view === 1;
      },
      userPermissionsContacts() {
        return this.getUserPermission('Contacts');
      },
      userPermissionsGroups() {
        return this.getUserPermission('Groups');
      },
      canViewContacts() {
        return this.userPermissionsContacts?.view === 1;
      },
      canViewGroups() {
        return this.userPermissionsGroups?.view === 1;
      },
      userPermissionsHours() {
        return this.getUserPermission('Hours');
      },
      canViewHours() {
        return this.userPermissionsHours?.view === 1;
      },
      userPermissionsHolidays() {
        return this.getUserPermission('Holidays');
      },
      canViewHolidays() {
        return this.userPermissionsHolidays?.view === 1;
      },
      userPermissionsReporting() {
        return this.getUserPermission('Reporting');
      },
      canViewReporting() {
        return this.userPermissionsReporting?.view === 1;
      },
      userPermissionsDaysOff() {
        return this.getUserPermission('Days off');
      },
      canViewDaysOff() {
        return this.userPermissionsDaysOff?.view === 1;
      },
      userPermissionsDaysOffReports() {
        return this.getUserPermission('Days off reports');
      },
      canViewDaysOffReports() {
        return this.userPermissionsDaysOffReports?.view === 1;
      },
      canViewDashboard() {
              return this.userPermissions?.view === 1;
          },
      superUser() {
          return this.getSuperUserPermission === 1;
      },
    },
    setup() {
      const isLoading = ref(false);
      const userInfo = ref(null); // Use cached user info if available
      const users = ref([]); // Ref to store fetched users
      const selectedUser = ref(null); // Ref to store selected user
      const showUsersContainer = ref(true); // Ref to control visibility of users container
      const menuItemsCollapsed = ref(['dashboard', 'contacts']);
  
      const isMenuOpen = ref(false); // Reactive variable to track menu state
      const isNotificationsOpen = ref(false); // Reactive variable to track notifications state
      const router = useRouter();
      const isSidebarOpen = ref(false);
      const isSidebarMini = ref(false);
      const route = useRoute();
      const showSearch = ref(true);
      const avatarUrl = ref('/img/profile_av.7b0dcddf.png');
  
      const pageHeader = ref(null);
      const notificationCount = ref(0); // Initialize notification count
      const isFetchingNotifications = ref(false); // Background task loading state
      const isActive = (path) => {
          return route.path === path || route.path.indexOf(path) !== -1;
        };
  
      const fetchNotificationCount = async () => {
    try {
      isFetchingNotifications.value = false; 
      // const response = await getAllUnreadNotifications();
      isLoading.value = false; // Access .value for ref modification
  
  
      // if (response && response.data && response.data.data) {
      //   notificationCount.value = response.data.data.length;
      // } else {
      //   console.error("Error in response format or no data received.");
      // }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      isFetchingNotifications.value = false; 
    }
  };
  
  
      
      watch(
        () => route.fullPath,
        (newPath, oldPath) => {
          fixPageHeader(newPath, oldPath);
        });
  
      const openMainMenuItem = (menuItem) => {
        const index = menuItemsCollapsed.value.indexOf(menuItem);
        if (index > -1) {
          menuItemsCollapsed.value.splice(index, 1);
        } else {
          menuItemsCollapsed.value.push(menuItem);
        }
      };
  
      const toggleSidebarMini = () => {
      isSidebarMini.value = !isSidebarMini.value;
      $('.sidebar').toggleClass('sidebar-mini');
  
      // Adjust the width of the logo
      const logoImg = document.querySelector('.logo-img');
      if (logoImg) {
          logoImg.style.width = isSidebarMini.value ? '6em' : '15em';
      }
  
      // Toggle visibility of the text inside menu links
      const spans = document.querySelectorAll('.menu-link span');
      spans.forEach(span => {
          if (isSidebarMini.value) {
              span.classList.add('hide-text'); // Hide the text
          } else {
              span.classList.remove('hide-text'); // Show the text
          }
      });
  
      // Center the images
      const menuImgs = document.querySelectorAll('.menu-img');
      menuImgs.forEach(img => {
          if (isSidebarMini.value) {
              img.classList.add('centered-img'); // Center images in mini mode
          } else {
              img.classList.remove('centered-img'); // Restore normal alignment
          }
      });
  
      // Remove 'open' class in mini mode
      if (isSidebarMini.value) {
          $('.sidebar').removeClass('open');
      }
  };
  
  
  
      const toggleSidebar = () => {
        isSidebarOpen.value = !isSidebarOpen.value;
  
        if (isSidebarOpen.value) {
          // Sidebar is open
          $('.sidebar').addClass('open');
          if (isSidebarMini.value) {
            $('.sidebar').addClass('sidebar-mini');
          }
        } else {
          // Sidebar is closed
  
          $('.sidebar').removeClass('open');
          $('.sidebar').removeClass('sidebar-mini');
        }
      };
  
      const isRtl = ref(false); // Add this line to define reactive variable for RTL mode
  
         
      // Watch for changes in RTL mode checkbox
      watch(isRtl, (newValue) => {
        if (newValue) {
          document.body.classList.add('rtl_mode');
        } else {
          document.body.classList.remove('rtl_mode');
        }
      });
  
  
      const startLoading = () => {
        isLoading.value = true;
      };
  
      const stopLoading = () => {
        isLoading.value = false;
      };
  
      const toggleMenu = () => {
        isMenuOpen.value = !isMenuOpen.value; // Toggle menu state
        isNotificationsOpen.value = false;
      };
  
      const getMentionType = (notificationType) => {
        switch (notificationType) {
          case 'DAYS_OFF_REQUEST_ACCEPTED':
            return 'DAYS OFF ▶ ACCEPTED';
          case 'DAYS_OFF_REQUEST_CREATION':
            return 'DAYS OFF ▶ CREATION';
          case 'DAYS_OFF_REQUEST_REJECTED':
            return 'DAYS OFF ▶ REJECTED';
          case 'HOURS_REQUEST_ACCEPTED':
            return 'HOURS ▶ ACCEPTED';
          case 'HOURS_REQUEST_CREATION':
            return 'HOURS ▶ CREATION';
          case 'HOURS_REQUEST_REJECTED':
            return 'HOURS ▶ REJECTED';
          case 'MANAGER_ASSIGNMENT_PROJECT':
            return 'ASSIGNMENT ▶ PROJECT MANAGER';
          case 'MANAGER_ASSIGNMENT_SUBTASK':
            return 'ASSIGNMENT ▶ SUBTASK MANAGER';
          case 'MANAGER_ASSIGNMENT_TASK':
            return 'ASSIGNMENT ▶ TASK MANAGER';
          case 'PROJECT_ASSIGNMENT':
            return 'ASSIGNMENT ▶ PROJECT';
          case 'PROJECT_COMMENT_MENTION':
            return 'PROJECT ▶ MENTION';
          case 'PROJECT_CREATOR_STATUS_CHANGES':
            return 'PROJECT ▶ STATUS CHANGE';
          case 'PROJECT_MANAGER_EDIT':
            return 'PROJECT ▶ CHANGE';
          case 'PROJECT_MANAGER_STATUS_CHANGES':
            return 'PROJECT ▶ STATUS CHANGE';
          case 'SUBTASK_ASSIGNMENT':
            return 'ASSIGNMENT ▶ SUBTASK';
          case 'SUBTASK_COMMENT_MENTION':
            return 'SUBTASK ▶ MENTION';
          case 'SUBTASK_CREATOR_STATUS_CHANGES':
            return 'SUBTASK ▶ STATUS CHANGE';
          case 'SUBTASK_MANAGER_EDIT':
            return 'SUBTASK ▶ CHANGE';
          case 'SUBTASK_MANAGER_STATUS_CHANGES':
            return 'SUBTASK ▶ STATUS CHANGE';
          case 'TASK_ASSIGNMENT':
            return 'ASSIGNMENT ▶ TASK';
          case 'TASK_COMMENT_MENTION':
            return 'TASK ▶ MENTION';
          case 'TASK_CREATOR_STATUS_CHANGES':
            return 'TASK ▶ STATUS CHANGE';
          case 'TASK_MANAGER_EDIT':
            return 'TASK ▶ CHANGE';
          case 'TASK_MANAGER_STATUS_CHANGES':
            return 'TASK ▶ STATUS CHANGE';
          case 'MISSING_HOURS_DAYS':
            return 'HOURS ▶ MISSING';
          case 'POTENTIAL_CLIENT_REMINDER':
            return 'CLIENT ▶ POTENTIAL REMINDER';
          case 'POTENTIAL_PROJECT_REMINDER':
            return 'PROJECT ▶ POTENTIAL REMINDER';
          case 'WRONG_HOSTING_EXPIRATION_DATA':
            return 'HOSTING ▶ WRONG EXPIRATION DATA';
          case 'HOSTING_WILL_EXPIRE':
            return 'HOSTING ▶ WILL EXPIRE';
          case 'HOSTING_EXPIRED':
            return 'HOSTING ▶ EXPIRED';
          default:
            return '-';
        }
      };
  
  
      const handleNotificationLinkClick = (event) => {
        event.preventDefault();
        const target = $(event.target);
        const dataId = target.attr('data-id');
        const dataType = target.attr('data-type');
  
        if (dataId) {
          switch (dataType) {
            case 'project':
              router.push({ path: '/project', query: { id: dataId } });
              break;
            case 'task':
              router.push({ path: '/task', query: { id: dataId } });
              break;
            case 'subtask':
              router.push({ path: '/subtask', query: { id: dataId } });
              break;
            case 'host':
              router.push({ path: '/host', query: { id: dataId } });
              break;
            // Add more cases here for different types
            default:
              console.log('Unknown data-type with ID:', dataType, dataId);
          }
        } else {
          switch (dataType) {
            case 'hours-creation':
              router.push({ path: '/hours-requests', query: {} });
              break;
            case 'days-off-creation':
              router.push({ path: '/days-off-requests', query: {} });
              break;
            case 'missing-hours-days':
              router.push({ path: '/hours', query: {} });
              break;
            // Add more cases here for different types
            default:
              console.log('Unknown data-type without ID:', dataType);
          }
        }
      };
  
      const getMentionTypeLink = (notification) => {
        let ret = '';
  
        if (notification.subtask_title) {
          ret = `in subtask <a href="#" class="notification-link" data-type="subtask" data-id="${notification.subtask_id}">${notification.subtask_title}</a>`;
        } else if (notification.task_title) {
          ret = `in task <a href="#" class="notification-link" data-type="task" data-id="${notification.task_id}">${notification.task_title}</a>`;
        } else if (notification.project_title) {
          ret = `in project <a href="#" class="notification-link" data-type="project" data-id="${notification.project_id}">${notification.project_title}</a>`;
        } else {
          let notificationType = '';
          if (notification.notificationType.indexOf('_REQUEST_') !== -1) {
            if (notification.notificationType.indexOf('CREATION') !== -1) {
              if (notification.notificationType.indexOf('DAYS_OFF') !== -1) {
                notificationType = 'days-off-creation';
                ret = `<a href="#" class="notification-link" data-type="${notificationType}">Days off requests</a>`;
              } else if (notification.notificationType.indexOf('HOURS') !== -1) {
                notificationType = 'hours-creation';
                ret = `<a href="#" class="notification-link" data-type="${notificationType}">Hours Requests</a>`;
              }
            } else if (notification.notificationType.indexOf('ACCEPTED') !== -1 || notification.notificationType.indexOf('REJECTED') !== -1) {
              if (notification.notificationType.indexOf('DAYS_OFF') !== -1) {
                notificationType = 'days-off-requests';
                ret = `<a href="#" class="notification-link" data-type="${notificationType}">Days off</a>`;
              } else if (notification.notificationType.indexOf('HOURS') !== -1) {
                notificationType = 'hours-requests';
                ret = `<a href="#" class="notification-link" data-type="${notificationType}">Hours</a>`;
              }
            }          
          } else {
            if (notification.notificationType == 'MISSING_HOURS_DAYS') {
              notificationType = 'missing-hours-days';
              ret = `<a href="#" class="notification-link" data-type="${notificationType}">Hours</a>`;
            } else if (notification.notificationType == 'POTENTIAL_CLIENT_REMINDER') {
              notificationType = 'potential-client-reminder';
              ret = `<a href="#" class="notification-link" data-type="${notificationType}">Clients</a>`;
            } else if (notification.notificationType == 'POTENTIAL_PROJECT_REMINDER') {
              notificationType = 'potential-project-reminder';
              ret = `<a href="#" class="notification-link" data-type="${notificationType}">${notification.description}</a>`;
            } else if (notification.notificationType == 'WRONG_HOSTING_EXPIRATION_DATA') {
              notificationType = 'wrong-hosting-expiration-data';
              ret = `<a href="#" class="notification-link" data-type="${notificationType}">${notification.description}</a>`;
            } else if (notification.notificationType == 'HOSTING_WILL_EXPIRE') {
              notificationType = 'hosting-will-expire';
              ret = `<a href="#" class="notification-link" data-type="${notificationType}">${notification.description}</a>`;
            } else if (notification.notificationType == 'HOSTING_EXPIRED') {
              notificationType = 'hosting-will-expire';
              ret = `<a href="#" class="notification-link" data-type="${notificationType}">${notification.description}</a>`;
            }
          }
        }
  
        if (notification.username) {
          ret += ` from: <span class="username">${notification.username}</span>`;
        }
  
        return ret;
      };
  
  
      const toggleNotificationMenu = async () => {
        isNotificationsOpen.value = !isNotificationsOpen.value; // Toggle notifications state
        isMenuOpen.value = false;
  
        if (isNotificationsOpen.value) {
          try {
            // Call getUnreadNotifications
            const response = await getAllUnreadNotifications();
  
            // Check if response and response.data exist
            if (response && response.data) {
              const notifications = response.data.data; // Access notifications directly
              // Check if notifications is an array
              if (Array.isArray(notifications)) {
                // Process notifications and update the UI
                const notificationsList = document.getElementById('notifications-list');
                notificationsList.innerHTML = ''; // Clear existing notifications
                $("#notificationsCount").text(notifications.length);
  
                notifications.forEach(notification => {
                  const listItem = document.createElement('li');
                  listItem.className = 'py-2 mb-1 border-bottom';
  
                  const notificationMessage = document.createElement('p');
                  notificationMessage.className = 'notification-message';
                  notificationMessage.innerHTML = getMentionType(notification.notificationType) + ': ' + getMentionTypeLink(notification); // Use innerHTML to render HTML content
                  listItem.appendChild(notificationMessage);
  
                  const timestamp = document.createElement('span');
                  timestamp.textContent = notification.created_at;
                  listItem.appendChild(timestamp);
  
                  notificationsList.appendChild(listItem);
                });
              } else {
                console.error("Notifications data is not in the expected format:", notifications);
              }
            } else {
              console.error("Response data is missing:", response);
            }
          } catch (error) {
            console.error("Failed to fetch notifications:", error);
          }
        }
      };
  
      const menuStyle = computed(() => ({
        top: isMenuOpen.value ? '100%' : 'initial',
        right: isMenuOpen.value ? '0' : 'initial'
      }));
  
      const notificationStyle = computed(() => ({
        top: isNotificationsOpen.value ? '100%' : 'initial',
        right: isNotificationsOpen.value ? '0' : 'initial'
      }));
  
      const fetchUserData = async () => {
        try {
          const response = await fetchUserInfo();
          userInfo.value = response.data || null;
          
          
          showUsersContainer.value = false; // Set showUsersContainer to false if conditions are not met

          if (response.data?.info.admin === 1) {
      router.push('/dashboard'); 
    } else if (response.data?.info.usertype_id === 2) {
      router.push('/dashboard-hospital'); 
    } 
        
        } catch (error) {
          console.error("Failed to fetch user data:", error);
        }
      };
  
      const fetchUsersData = async () => {
        try {
          const response = await fetchUsers();
          showUsersContainer.value = response.data.success; // Set showUsersContainer based on response success
          if (response.data.success) {
            users.value = response.data.data; // Update users ref with response data
          } else {
            console.error("Failed to fetch users:", response.data.message);
          }
        } catch (error) {
          showUsersContainer.value = false; // Set showUsersContainer to false in case of error
          console.error("Failed to fetch users:", error);
        }
      };
  
      // Handle user change
      const changeUserHandler = async (userId) => {
        const userInfo = await fetchUserInfo();
        if (userInfo.data.info?.id) {
          if (userId && parseInt(userInfo.data.info?.id) != parseInt(userId)) {
            const toast = useToast();
            try {
              const response = await changeUser(userId); // Call the changeUser function with the selected userId
              if (response.data.success) {
                // Update the Authorization header with the new token
                const newToken = response.data.data.token.plainTextToken;
  
                localStorage.removeItem('api_token');
                localStorage.setItem('api_token', newToken);
  
                await fetchUserData();
  
                toast.success(response.data.message); // Show success message
  
                // Reload the page
                window.location.reload();
              } else {
                toast.error(response.data.message); // Show error message
              }
            } catch (error) {
              console.error('Error changing user:', error);
              toast.error('An error occurred while changing the user.'); // Show generic error message
            }
          }
        }
      };
  
      const closeMenu = (event) => {
        if (!document.querySelector('.user-menu').contains(event.target) ) {
          isMenuOpen.value = false;
        }
       
      };
  

    const logout = async (event) => {
      event.preventDefault();

      try {
        const response = await logoutUser(); 

        console.log(response);

        // clear frontend tokens
        localStorage.removeItem('api_token');
        localStorage.removeItem('main_auth_token');

        // redirect to GSIS logout if backend returned it
        if (response?.data?.redirectUrl) {
          window.location.href = response.data.redirectUrl;
        } else {
          router.push('/');
        }
      } catch (error) {
        console.error('Logout failed', error);
      }
    };



      const info = (event)=>{
        $("#modal-info").modal('show');

      }
  
      const theme = ref(localStorage.getItem('theme') || 'dark'); // Default theme is 'dark'
  
      const switchTheme = (e) => {
        if (e.target.checked) {
          document.documentElement.setAttribute('data-theme', 'dark');
          localStorage.setItem('theme', 'dark');
        } else {
          document.documentElement.setAttribute('data-theme', 'light');
          localStorage.setItem('theme', 'light');
        }
      };
  
      const fixPageHeader = (newPath, oldPath) => {
        if (newPath.indexOf('/dashboard') !== -1 || newPath.indexOf('/holidays') !== -1 || newPath.indexOf('/days-off') !== -1 || newPath.indexOf('/notifications') !== -1 || newPath.indexOf('/days-off-reports') !== -1 || newPath.indexOf('/hours') !== -1 || newPath.indexOf('/missing-hours') !== -1 || newPath.indexOf('/days-off-requests') !== -1 || newPath.indexOf('/hours-requests') !== -1) {
            showSearch.value = false;
          } else {
            showSearch.value = true;
          }
  /* 
          if(newPath.indexOf('/dashboard') !== -1){
            pageHeader.value = 'ΠΑΡΑΚΟΛΟΥΘΗΣΗ ΚΑΙ ΕΛΕΓΧΟΣ ΔΙΑΚΙΝΗΣΗΣ
  ΙΣΤΙΚΩΝ ΜΟΣΧΕΥΜΑΤΩΝ';
          }
          if(newPath.indexOf('/follow-up') !== -1){
            pageHeader.value = 'Follow Up';
  
          }
          if(newPath.indexOf('/to-do') !== -1){
            pageHeader.value = 'To Do';
          }
        
        
          if(newPath.indexOf('/missing-hours') !== -1){
            pageHeader.value = 'Missing Hours Panel';
          } 
          if(newPath.indexOf('/users') !== -1){
            pageHeader.value = 'Users';
          } 
          if(newPath.indexOf('/project') !== -1){
            pageHeader.value = 'Project';
          }
          if(newPath.indexOf('/projects') !== -1){
            pageHeader.value = 'Projects';
          }
          if(newPath.indexOf('/hosting') !== -1){
            pageHeader.value = 'Hosting';
          }
          if(newPath.indexOf('/services') !== -1){
            pageHeader.value = 'Services';
          }
          if(newPath.indexOf('/groups') !== -1){
            pageHeader.value = 'Groups';
          }
          if(newPath.indexOf('/clients') !== -1){
            pageHeader.value = 'Clients';
          }
          if(newPath.indexOf('/suppliers') !== -1){
            pageHeader.value = 'Suppliers';
          }
          if(newPath.indexOf('/contacts-clients') !== -1){
            pageHeader.value = 'Contacts Clients';
          }
          if(newPath.indexOf('/contacts-suppliers') !== -1){
            pageHeader.value = 'Contacts Suppliers';
          }
          if(newPath.indexOf('/orphaned-contacts') !== -1){
            pageHeader.value = 'Orphaned Contacts';
          }
          if(newPath.indexOf('/days-off') !== -1){
            pageHeader.value = 'Days Off';
          }
          if(newPath.indexOf('/days-off-reports') !== -1){
            pageHeader.value = 'Days Off Reports';
          }
          if(newPath.indexOf('/holidays') !== -1){
            pageHeader.value = 'Holidays';
          }
          if(newPath.indexOf('/reports') !== -1){
            pageHeader.value = 'Reports';
          }
          if(newPath.indexOf('/hours') !== -1){
            pageHeader.value = 'Hours';
          }
          if(newPath.indexOf('/history-changes') !== -1){
            pageHeader.value = 'Ιστορικό αλλαγών σε clients';
          }
          if(newPath.indexOf('/notifications') !== -1){
            pageHeader.value = 'Notifications';
          }
          if(newPath.indexOf('/change-profile') !== -1){
            pageHeader.value = 'Επεξεργασία Λογαριασμού';
          }
          if(newPath.indexOf('/my-permissions') !== -1){
            pageHeader.value = 'My permissions';
          }
  
          if(newPath.indexOf('/hours-requests') !== -1){
            pageHeader.value = 'Hours Requests';
          }
           if(newPath.indexOf('/days-off-requests') !== -1){
            pageHeader.value = 'Days Off Requests';
          } 
          
          if(newPath.indexOf('/task') !== -1){
            pageHeader.value = 'Task';
          }
          if(newPath.indexOf('/subtask') !== -1){
            pageHeader.value = 'Subtask';
          }
          if(newPath.indexOf('/notification-settings') !== -1){
            pageHeader.value = 'Notification Settings';
          } */
      };
  
      // Fetch notifications every 2 seconds
      let notificationInterval;
  
  
      onMounted(() => {
       
        fixPageHeader(window.location.href, window.location.href);
  
        if (!userInfo.value) {
          fetchUserData(); // Fetch user info if not already cached
        }
  
  
        $(document.body).on('click', '.notification-link', handleNotificationLinkClick);
  
        document.addEventListener('click', closeMenu);
  
        const currentTheme = localStorage.getItem('theme');
  
        if (currentTheme) {
          document.documentElement.setAttribute('data-theme', currentTheme);
        }
        router.beforeEach((to, from, next) => {
          startLoading();
          next();
        });
  
        router.afterEach(() => {
          stopLoading();
        });
  
        fetchNotificationCount(); // Fetch initial count
  
      });
  
      onUnmounted(() => {
        $(document.body).off('click', '.notification-link', handleNotificationLinkClick);
        document.removeEventListener('click', closeMenu);
        clearInterval(notificationInterval); // Clear interval when component is destroyed
  
      });
  
      // Define a method to toggle between light and dark modes
      const toggleTheme = () => {
        isLightMode.value = !isLightMode.value; // Toggle between dark and light mode
        const newTheme = isLightMode.value ? 'dark' : 'light'; // Determine the new theme
        document.documentElement.setAttribute('data-theme', newTheme); // Update the theme attribute of the root element
        localStorage.setItem('theme', newTheme); // Save the theme preference to local storage
      };
  
      return {
        showSearch,
        userInfo,
        users,
        selectedUser,
        menuStyle,
        toggleMenu,
        isMenuOpen,
        isNotificationsOpen,
        toggleNotificationMenu,
        notificationStyle,
        menuItemsCollapsed,
        notificationCount,
        openMainMenuItem,
        showUsersContainer,
        changeUserHandler,
        isLightMode,
        toggleTheme,
        theme,
        switchTheme,
        isLoading,
        toggleSidebar,
        isSidebarOpen,
        isSidebarMini,
        isRtl,
        toggleSidebarMini,
        logout,
        avatarUrl,
        info,
        pageHeader,
        isActive
      };
    }
  };
  </script>
  
  
  <style scoped>
  .submenu.collapsed {
    display: none;
  }
  
  .submenu.collapse {
    display: block;
  }
  
  .arrow.icofont-dotted-up {
    transform: rotate(180deg);
  }
  .page-header {
    font-size: 2rem;
    font-weight: 700;
  }
  .btn {
      box-shadow: 0px 0px 0px rgba(0, 0, 0, 0); /* Adjust values as needed */
  }
  .centered-img {
      display: block;
      margin-left: 1.5em; /* Center-align the image */
  }
  .notifications {
    position: relative;
  }
  
  #notificationBadge {
    position: absolute;
    top: 5px;
    right: -3px;
    transform: translate(50%, -70%); /* To adjust the badge's position */
  }
  
  .menu-link{
    position: relative;
      text-overflow: ellipsis;
      padding: 5px;
      overflow: hidden;
      white-space: nowrap;
      background: #fff;
      border-bottom: #d1d1d1 solid 1px;
      border-color: #d1d1d1;  
      border-width: 1px;
  
  }
  
  .hide-text {
      display: none; /* Hide the text */
  }
  
  .centered-img {
      margin: 0 auto; /* Center the image horizontally */
      display: block;
  }
  .x-panel-body-default {
      background: #f6f6f6;
      border-color: #d1d1d1;
      color: #404040;
      font-size: 13px;
      font-weight: 300;
      font-family: 'Open Sans', 'Helvetica Neue', helvetica, arial, verdana, sans-serif;
      border-width: 1px;
      border-style: solid;
      cursor: pointer;
      padding:5px;
  }
  
  .list-group-item:hover{
     background-color: #6DB4E3;
     color:white;
  }
  
  .active {
   background-color: #ffefbb;
  }
  .centered-img {
    display: flex;
    justify-content: center;
    align-items: end;
    width: 100%; /* Ensure full width for centering */
    margin: 0; /* Remove any extra margins */
  }

  .modal-header{
   background-color: #6DB4E3;
}

.modal-title{
color:white;
}

#modal-info{
  top:20%;
  border:none;
}

.btn2{
    background-color: #f6f6f6;
    border-color: #e5e5e5;
}

.btn2:hover, .btn-md:hover{
    background-color: #ececec;
}

.implant_details {
    flex: 0.32; /* Adjusted to match shrink */
    overflow-y: auto;
    transition: all 0.3s ease-in-out;
    padding-left: 10px;
    border-left: 1px solid rgb(94, 94, 94);
    margin-left: 10px;
    min-width: 280px; /* Ensure the details panel doesn't shrink too much */
}

.implant-details-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
}

.implant-detail {
    background: #fff;
    border-radius: 15px;
    box-shadow: 3px 3px 15px #c2c2c2;
    padding: 8px;
    width: calc(100% - 20px); /* Default to full width */
    padding-left: 10px;
    font-size:medium;
}
.submenu {
  list-style: none;
  margin: 0;
  padding: 0;
}

.submenu li {
  margin-top: 5px;
}

  </style>